/**
 * Bridge no-React para que helpers (p. ej. toLocalDateStringYMD) lean la fecha
 * operativa de sesión sin depender de Context.
 */
export type FechaOperativaSnapshot = {
  /** YYYY-MM-DD; null = usar reloj real */
  ymd: string | null;
  /** HH:mm opcional */
  hora: string | null;
};

export const FECHA_OPERATIVA_STORAGE_PREFIX = 'eone.fechaOperativa';

let snapshot: FechaOperativaSnapshot = { ymd: null, hora: null };

export const getFechaOperativaSnapshot = (): FechaOperativaSnapshot => snapshot;

export const setFechaOperativaSnapshot = (next: FechaOperativaSnapshot): void => {
  snapshot = {
    ymd: next.ymd,
    hora: next.hora,
  };
};

/** Limpia override en memoria y todas las claves de sessionStorage (logout). */
export const clearFechaOperativaSession = (): void => {
  snapshot = { ymd: null, hora: null };
  try {
    const keysToRemove: string[] = [];
    for (let i = 0; i < sessionStorage.length; i += 1) {
      const key = sessionStorage.key(i);
      if (key && key.startsWith(FECHA_OPERATIVA_STORAGE_PREFIX)) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach((key) => sessionStorage.removeItem(key));
  } catch {
    // sessionStorage no disponible
  }
};

/** Date efectiva para defaults de documentos (fecha operativa o ahora). */
export const getFechaOperativaDate = (): Date => {
  if (!snapshot.ymd || !/^\d{4}-\d{2}-\d{2}$/.test(snapshot.ymd)) {
    return new Date();
  }
  const [y, m, d] = snapshot.ymd.split('-').map(Number);
  let hh = 12;
  let mm = 0;
  if (snapshot.hora && /^\d{2}:\d{2}$/.test(snapshot.hora)) {
    const [h, min] = snapshot.hora.split(':').map(Number);
    hh = h;
    mm = min;
  }
  return new Date(y, m - 1, d, hh, mm, 0, 0);
};
